module.exports = __webpack_public_path__ + "img/ketersediaan.4516c760.jpg";